import React from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '../common/toolTip';
import FinancialChart from '../common/dashboard6/financialChart';
const Dashboard6 = () => {

	return (
		<>
			<div className="container-fluid">
				<div className="block-header">
					<div className="row clearfix">
						<div className="col-md-6 col-sm-12">
							<h1>Dashboard</h1>
							{/* <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/">Oculux</Link></li>
                                    <li className="breadcrumb-item"><Link to="/">My page</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Finance Performance</li>
                                </ol>
                            </nav> */}
						</div>
						{/* <div className="col-md-6 col-sm-12 text-right hidden-xs">
                            <a href="/" className="btn btn-sm btn-primary mr-1" title="">Create Campaign</a>
                            <a href="https://themeforest.net/item/oculux-bootstrap-4x-admin-dashboard-clean-modern-ui-kit/23091507" className="btn btn-sm btn-success" title="Themeforest"><i className="icon-basket"></i> Buy Now</a>
                        </div> */}
					</div>
				</div>

				<div className="row clearfix">
					<div className="col-lg-3 col-md-6">
						<div className="card">
							<div className="body">
								<div>Total Member</div>
								<div className="py-1 m-0 text-center h3 text-success">9,452</div>
								<div className="d-flex">
									<small className="text-muted">Last Month</small>
									<div className="ml-auto"><i className="fa fa-caret-up text-success"></i>12</div>
								</div>
							</div>
						</div>
						<div className="card">
							<div className="body">
								<div>Newsletter Subscribers</div>
								<div className="py-1 m-0 text-center h3 text-info">12,258</div>
								<div className="d-flex">
									<small className="text-muted">Open Rate</small>
									<div className="ml-auto">92%</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="card">
							<div className="body">
								<div>CME Program</div>
								<div className="py-1 m-0 text-center h3 text-success">182</div>
								<div className="d-flex">
									<small className="text-muted">Upcoming Programs</small>
									<div className="ml-auto">12</div>
								</div>
							</div>
						</div>
						<div className="card">
							<div className="body">
								<div>News Member</div>
								<div className="py-1 m-0 text-center h3 text-info">129</div>
								<div className="d-flex">
									<small className="text-muted">This Quarter</small>
									<div className="ml-auto"> </div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="card">
							<div className="body">
								<div>Event Registration</div>
								<div className="py-1 m-0 text-center h3 text-success">892</div>
								<div className="d-flex">
									<small className="text-muted">Email Campaigns</small>
									<div className="ml-auto"><i className="fa fa-caret-up text-success"></i>12</div>
								</div>
							</div>
						</div>
						<div className="card">
							<div className="body">
								<div>Certification Updates</div>
								<div className="py-1 m-0 text-center h3 text-info">245</div>
								<div className="d-flex">
									<small className="text-muted">Send This Month</small>
									<div className="ml-auto"> </div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="card">
							<div className="body">
								<div className="media">
									<div className="media-body">
										<h5 className="m-0">Upcoming Events</h5>
									</div>
								</div>
								<div>
									<div>
										<b className="text-muted">Annual Confermation 2024 </b>
										<p>Aug 15-17,2024</p>
									</div>
									<div> </div>

								</div>
								<div>
									<b className="text-muted">Advanced Laparoscopy Workshop </b>
									<p>Jul 15-17,2024</p>
								</div>
								<div>
									<b className="text-muted">CME Program: Latest Techniques</b>
									<p>Jul 15-17,2024</p>
								</div>
							</div>
						</div>
					</div>
					{/* <div className="col-lg-6 col-md-12">
                        <div className="row clearfix">
                            <div className="col-lg-6 col-md-6">
                              
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="card">
                                    <div className="body">
                                        <div className="card-text">
                                            <div className="mt-0">
                                                <small className="float-right text-muted">10/200 GB</small>
                                                <span>Memory</span>
                                                <div className="progress progress-xxs">
                                                    <div style={{ width: "60%" }} className="progress-bar"></div>
                                                </div>
                                            </div>
                                            <div className="mt-4">
                                                <small className="float-right text-muted">40 MB</small>
                                                <span>Bandwidth</span>
                                                <div className="progress progress-xxs">
                                                    <div style={{ width: "50%" }} className="progress-bar"></div>
                                                </div>
                                            </div>
                                            <div className="mt-4">
                                                <small className="float-right text-muted">73%</small>
                                                <span>Activity</span>
                                                <div className="progress progress-xxs">
                                                    <div style={{ width: "40%" }} className="progress-bar"></div>
                                                </div>
                                            </div>
                                            <div className="mt-4">
                                                <small className="float-right text-muted">400 GB</small>
                                                <span>FTP</span>
                                                <div className="progress progress-xxs mb-0">
                                                    <div style={{ width: "80%" }} className="progress-bar bg-danger"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
				</div>

				<div className="row clearfix">
					<div className="col-lg-6 col-md-12">
						<div className="card">
							<div className="header">
								<h2>Member Engagement Trends</h2>
							</div>
							<div className="body">
								<FinancialChart />
							</div>
						</div>
					</div>
					<div className="col-lg-6 col-md-12">
						<div className="card">
							<div className="header">
								<h2>Login Status</h2>
							</div>
							<div className="body">
								<div className="table-responsive">
									<table className="table table-hover table-custom spacing5">
										<thead>
											<tr>
												<th style={{ width: "20px" }}>S.NO</th>
												<th>Name</th>
												<th style={{ width: "50px" }}>Status</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>
													<span>01</span>
												</td>
												<td>
													<div className="d-flex align-items-center">
														<Tooltip text="Avatar Name" id="client1" />
														<div className="avtar-pic w35 bg-red" data-for="client1" data-tip title="Avatar Name"><span>SS</span></div>
														<div className="ml-3">
															<Link to="/page-invoices-details" title="">South Shyanne</Link>
															<p className="mb-0">south.shyanne@example.com</p>
														</div>
													</div>
												</td>
												<td><span className="badge badge-success ml-0 mr-0">Active</span></td>
											</tr>
											<tr>
												<td>
													<span>02</span>
												</td>
												<td>
													<div className="d-flex align-items-center">
														<img src="../assets/images/xs/avatar2.jpg" data-toggle="tooltip" data-placement="top" title="Avatar Name" alt="Avatar" className="w35 h35 rounded" />
														<div className="ml-3">
															<Link to="/" title="">Zoe Baker</Link>
															<p className="mb-0">zoe.baker@example.com</p>
														</div>
													</div>
												</td>

												<td><span className="badge badge-success ml-0 mr-0">Active</span></td>

											</tr>
											<tr>
												<td>
													<span>03</span>
												</td>
												<td>
													<div className="d-flex align-items-center">
														<div className="avtar-pic w35 bg-indigo" data-toggle="tooltip" data-placement="top" title="Avatar Name"><span>CB</span></div>
														<div className="ml-3">
															<Link to="/" title="">Colin Brown</Link>
															<p className="mb-0">colinbrown@example.com</p>
														</div>
													</div>
												</td>

												<td><span className="badge badge-success ml-0 mr-0">Active</span></td>

											</tr>
											<tr>
												<td>
													<span>04</span>
												</td>
												<td>
													<div className="d-flex align-items-center">
														<div className="avtar-pic w35 bg-green" data-toggle="tooltip" data-placement="top" title="Avatar Name"><span>KG</span></div>
														<div className="ml-3">
															<Link to="/" title="">Kevin Gill</Link>
															<p className="mb-0">kevin.gill@example.com</p>
														</div>
													</div>
												</td>

												<td><span className="badge badge-warning  ml-0 mr-0">5 min ago</span></td>

											</tr>

										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* <div className="row clearfix">
                    <div className="col-lg-12 col-md-12">
                        <div className="card">
                            <div className="header">
                                <h2>Financial Management Review</h2>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-custom spacing5">
                                    <thead>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Actual Cost</th>
                                            <th>Forecast Cost</th>
                                            <th>Revenue</th>
                                            <th className="w100">% Margin</th>
                                            <th>Actual</th>
                                            <th className="w100">Forecast</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Building</td>
                                            <td>11,243</td>
                                            <td>399,21</td>
                                            <td>40,234</td>
                                            <td><span className="text-green">8.1%</span></td>
                                            <td>2,93,098</td>
                                            <td>1,02,243</td>
                                        </tr>
                                        <tr>
                                            <td>Digital</td>
                                            <td>1,22,877</td>
                                            <td>5,00,215</td>
                                            <td>40,159</td>
                                            <td><span className="text-red">6.4%</span></td>
                                            <td>2,93,091</td>
                                            <td>9,32,456</td>
                                        </tr>
                                        <tr>
                                            <td>Health</td>
                                            <td>32,375</td>
                                            <td>99,852</td>
                                            <td>20,194</td>
                                            <td><span className="text-green">12.9%</span></td>
                                            <td>18,654</td>
                                            <td>29,201</td>
                                        </tr>
                                        <tr>
                                            <td>Power</td>
                                            <td>76,877</td>
                                            <td>98,565</td>
                                            <td>123,022</td>
                                            <td><span className="text-red">17.0%</span></td>
                                            <td>10,800</td>
                                            <td>22,232</td>
                                        </tr>
                                        <tr>
                                            <td>Transport</td>
                                            <td>2,232</td>
                                            <td>3,099</td>
                                            <td>400</td>
                                            <td><span className="text-green">1.2%</span></td>
                                            <td>13,255</td>
                                            <td>14,765</td>
                                        </tr>
                                        <tr>
                                            <td>Total</td>
                                            <td>3,33,985</td>
                                            <td>4,68,444</td>
                                            <td>99,400</td>
                                            <td><span className="text-green">34.2%</span></td>
                                            <td>28,643,091</td>
                                            <td>42,31,765</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div> */}

			</div>
		</>

	);

}


export default Dashboard6